module.exports = __webpack_public_path__ + "media/images/categories/headers/technology-and-innovation-ed6b25335c433099e398ff7decfe9437.jpg";